<template>
  <div class="vx-row">
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div v-else class="w-full">
      <div
        slot="no-body"
        class="tabs-container inventory_tabSec"
        id="view-customer-tab"
      >
        <vx-card>
          <vs-table
            :max-items="paginationItems[1]"
            pagination
            :data="hardwareUomList"
            :description="false"
            @selected="handleSelected"
            search
            :description-items="paginationItems"
            description-title="Registries"
            description-connector="of"
            description-body="Pages"
          >
            <template slot="header">
              <div class="heading">
                {{ $t("setup.label.UOM(Unit Of measurement)") }}
              </div>
              <div class="mr-2 mb-1 order-1">
                <vs-button
                  icon-pack="feather"
                  icon="icon-plus"
                  @click="$router.push({ name: 'Create UOM' })"
                  size="small"
                  >{{ $t("setup.label.CreateUOM") }}</vs-button
                >
              </div>
            </template>
            <template slot="thead">
              <vs-th>{{ $t("setup.label.Id") }}</vs-th>
              <vs-th>{{ $t("setup.label.Name") }}</vs-th>
              <vs-th>{{ $t("setup.label.Description") }}</vs-th>
              <vs-th class="tHeadCenter">{{ $t("setup.label.Action") }}</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr
                :key="index"
                :data="hardwareUomList"
                v-for="(hardwareUomList, index) in data"
              >
                <vs-td :data="hardwareUomList.id">{{
                  hardwareUomList.id
                }}</vs-td>
                <vs-td :data="hardwareUomList.Name">{{
                  hardwareUomList.Name
                }}</vs-td>

                <vs-td :data="hardwareUomList.Description">{{
                  hardwareUomList.Description
                }}</vs-td>
                <vs-td class="whitespace-no-wrap">
                  <div class="container_img">
                    <feather-icon
                      icon="EditIcon"
                      :title="$t('setup.label.Edit')"
                      svgClasses="w-5 h-5  stroke-current cursor orange_icon"
                      @click.stop="editCreateDevice(hardwareUomList.id)"
                      class="icon_row"
                    />
                    <feather-icon
                      icon="TrashIcon"
                      :title="$t('setup.label.Delete')"
                      svgClasses="w-5 h-5 text-danger stroke-current cursor"
                      @click.stop="
                        editJobsUomPopup = true;
                        deleatId = hardwareUomList.id;
                      "
                      class="icon_row"
                    />
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <div class="centerx">
            <vs-popup
              classContent="popup-example"
              :title="$t('setup.label.DeleteUOM')"
              :active.sync="editJobsUomPopup"
              class="popup-close small-popup"
            >
              <div class="center">
                <img src="@/assets/images/pages/delete.svg" />
                <div class="success-msg">
                  {{ $t("system.label.areYouSureDelete") }}
                </div>
              </div>

              <div class="center">
                <span class="p-2">
                  <vs-button type="border" @click="editJobsUomPopup = false">{{
                    $t("system.label.cancel")
                  }}</vs-button></span
                >

                <span class="p-2">
                  <vs-button @click="deleteUomTeam(deleatId)">{{
                    $t("system.label.confirm")
                  }}</vs-button>
                </span>
              </div>
              <div style="height: 20px"></div>
            </vs-popup>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>
<script>
import { AtomSpinner } from "epic-spinners";
import { mapState } from "vuex";

export default {
  data() {
    return {
      loading: false,
      paginationItems: [5, 10, 15],
      deletePopup: false,
      delId: 0,
      deleatId: 0,
      editJobsPopup: false,
      editJobsUomPopup: false,
      editJobsRumPopup: false,
      // provisioningRumList: [],
      // hardwareUomList: [],
      provisioningActionsList: [],
      networkElementList: [],
      timeList: [],
    };
  },
  components: { AtomSpinner },

  computed: {
    ...mapState({
      hardwareUomList: (state) => state.usageRating.Uomlist,
      provisioningRumList: (state) => state.usageRating.Rumlist,
      Timemodel: (state) => state.usageRating.GetTimePeriod,
      broadcasters: (state) => state.usageRating.GetTemplate,
      products: (state) => state.usageRating.GetUsageRatePlan,
      timemodel: (state) => state.usageRating.timeModelList,
    }),
  },
  methods: {
    async getUomData() {
      this.loading = true;
      try {
        this.$store.dispatch("usageRating/setUomList", {});
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },

    editCreateDevice(id) {
      this.$router.push({ name: "Edit UOM", params: { id: id } });
    },

    handleSelected(hardwareUomList) {
      this.$router.push({
        name: "View UOM",
        params: { id: hardwareUomList.id },
      });
    },

    async deleteUomTeam(id) {
      try {
        await this.$store.dispatch(
          "usageRating/deleteUnitofMeasurementAction",
          id
        );
        this.$swal({
          title: "Success",
          icon: "success",
          text: "UOM Successfully Deleted",
          type: "success",
        });
        this.getUomData();
        this.editJobsUomPopup = false;
      } catch (e) {
        this.$toasted.error(e.message);
      }
    },
  },
  mounted() {
    this.getUomData();
  },
};
</script>
<style scoped>
::v-deep .vs-tabs--ul {
  width: 90%;
}
.inventory_tabSec >>> .con-vs-tabs .vs-tabs--ul {
  box-shadow: none !important;
}
.heading {
  margin-right: auto;
  font-size: 1.5rem;
  font-weight: 600;
  margin-left: 5px;
}
</style>
